import { createContext, ReactNode, useContext, useState } from 'react';

type EmailConsentContextType = {
  emailConsent: boolean;
  setEmailConsent: (consent: boolean) => void;
}

const EmailConsentContext = createContext<EmailConsentContextType | undefined>(undefined);

type EmailConsentProviderProps = {
  children: ReactNode;
}

/**
 * Провайдер контекста для хранения состояния согласия на email рассылку
 * Используется для передачи значения из формы регистрации в процесс создания пользователя
 */
export const EmailConsentProvider = ({ children }: EmailConsentProviderProps) => {
  const [emailConsent, setEmailConsent] = useState<boolean>(false);

  return (
    <EmailConsentContext.Provider value={{ emailConsent, setEmailConsent }}>
      {children}
    </EmailConsentContext.Provider>
  );
};

/**
 * Хук для использования контекста согласия на email рассылку
 */
export const useEmailConsentContext = () => {
  const context = useContext(EmailConsentContext);
  if (context === undefined) {
    throw new Error('useEmailConsentContext must be used within an EmailConsentProvider');
  }
  return context;
};